module.exports = __webpack_public_path__ + "static/media/logo.c893d11f.svg";